export const AFFILIATES_LOGOS = [
  'cozycozy',
  'gha',
  'hotelscan',
  'neredekal',
  'skyscanner',
  'tripadvisor',
  'trivago',
  'wego',
  'vio',
  'findhotel',
  'idealo',
]
